import { FC } from "react";
import { AuthenticatedLayout } from "../../layouts";
import { WebROESubmission } from "../../components/WebROESubmission";

export interface IWebROESubmissionPage {}

export const WebROESubmissionPage: FC<IWebROESubmissionPage> = () => {
	return (
		<AuthenticatedLayout
			pageTitle="Web ROE Submission"
			breadcrumbCurrentPageName=""
			breadcrumbLinks={[]}
			mainContents={<WebROESubmission />}
		/>
	);
};
